export const FULL_LOADING = "FULL_LOADING"

export function toggleFullLoading(loading) {
  return { loading, type: FULL_LOADING }
}
